
angular.module('bmsApp.crm.customer').controller('ContactModalFormCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'$filter',
	'$modalInstance',
	'$ngBootbox',
	'FormOptionsSvc',
	'ContactDetailTypeSvc',
	'ContactSvc',
	'contact', function (
		$scope,
		$q,
		$timeout,
		$filter,
		$modalInstance,
		$ngBootbox,
		FormOptionsSvc,
		ContactDetailTypeSvc,
		ContactSvc,
		contact) {

		$scope.contactDetailTypeGroups = [
			{
				type: 'phone',
				label: 'Phone'
			},
			{
				type: 'email',
				label: 'Email'
			},
			{
				type: 'web',
				label: 'Web'
			}
		];

		var promises = [
			FormOptionsSvc.title(),
			ContactDetailTypeSvc.options()
		];

		$scope.loading = true;
		$scope.processing = false;

		$q.all(promises)
			.then(function (responses) {
				$timeout(function () {
					$scope.$apply(function () {
						$scope.contact = angular.extend($scope.contact = {
							contact_details: []
						}, contact);
						$scope.titleOptions = responses[0].data.options;
						$scope.contactDetailTypeOptions = responses[1].data.options;
						$scope.loading = false;
					});
				});
			});

		$scope.addContactDetail = function (group) {
			// find and apply the first contact detail type of group
			$scope.contact.contact_details.push({
				contact_detail_type: $filter('filter')($scope.contactDetailTypeOptions, {group: group})[0]
			});
		};

		$scope.removeContactDetail = function (contactDetail) {
			if (contactDetail.id) {
				contactDetail.delete = true;
			}
			else {
				var index = $scope.contact.contact_details.indexOf(contactDetail);
				$scope.contact.contact_details.splice(index, 1);
			}
		};

		$scope.formvalidatorconfig = {
			submitHandler: function () {
				$scope.submit($scope.contact);
			},
			errorPlacement: function (error) {
				error.appendTo('#contact-errors');
			},
			errorContainer: '#contact-errors'
		};

		$scope.submit = function (contact) {
			$scope.processing = true;
			var modalResult = {};
			var savePromise = contact.id ? ContactSvc.update(contact) : ContactSvc.create(contact);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = contact.id ? 'update' : 'create';
					modalResult.contact = contact;
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error;
					$modalInstance.close(modalResult);
				})
				.finally(function() {
					$scope.processing = false;
				});
		};

		$scope.cancel = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};
		
	}]);
